module.exports = "<ngx-loading [show]=\"loading\"></ngx-loading>\n\n<div class=\"card-header\">\n\t<h4 class=\"card-title\">Nuevo cliente</h4>\n\t<hr>\n</div>\n<div class=\"card-content\">\n\t<app-cliente-frm-add></app-cliente-frm-add>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/ventas/cliente-add/cliente-add.component.html
// module id = ../../../../../src/app/components/ventas/cliente-add/cliente-add.component.html
// module chunks = main